@if (authService.isLoggedIn() && !isPublicRoute()) {
  <div class="layout-container" [class.sidebar-open]="sidebarService.isOpen()">
    <app-sidebar></app-sidebar>
    
    @if (sidebarService.isMobile() && sidebarService.isOpen()) {
      <div class="sidebar-backdrop" (click)="sidebarService.close()"></div>
    }

    <div class="main-content">
      <app-header></app-header>
      <main class="content-body">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
} @else {
  <main class="auth-layout">
    <router-outlet></router-outlet>
  </main>
}
